// extracted by mini-css-extract-plugin
module.exports = {"page":"GameAreaList_page__2QWUO","mainTable":"GameAreaList_mainTable__1nYyb"};